import * as TherapistApis from '../apis/therapist';
import * as CustomApis from '../apis/custom';
import * as UserApis from '../apis/user';
import * as ActionTypes from '../constants/actions';
import * as AuthUtils from '../utils/auth';
import _ from 'lodash';


export function setChatList(chatList) {
	return {
		type : ActionTypes.MESSAGES.SET_CHAT_LIST,
        chatList
	};
}

export function setMessageList(messageList) {
	return {
		type : ActionTypes.MESSAGES.SET_MESSAGE_LIST,
        messageList
	};
}

export function appendMessageList(messageList, chatId) {
	return {
		type : ActionTypes.MESSAGES.APPEND_MESSAGE_LIST,
        messageList, chatId
	};
}


export function setUserAccess(userAccess) {
	return {
		type : ActionTypes.MESSAGES.SET_USER_ACCESS,
        userAccess
	};
}